<script setup lang="ts">

import { useRouter } from "vue-router";

const props = defineProps<{
	to: string;
	linkText: string;
	title?: string;
	params?: any;
	disabled?: boolean;
}>();

const router = useRouter();

const route = router.getRoutes().find(value => value.name === props.to);
if (!route)
	throw new Error(`Route ${props.to} not found`);
const title = props.title ?? route?.meta.title;

const link = router.resolve({
	name: props.to,
	params: props.params ?? {}
});

</script>

<template>
	<div class="card">
		<div class="card-header">
			<p class="card-header-title">
				{{ title }}
			</p>
		</div>
		<div class="card-content">
			<div class="content">
				<slot />
			</div>
			<router-link v-if="!disabled" :to="link" class="button is-primary">
				{{ props.linkText }}
			</router-link>
		</div>
	</div>
</template>

<style scoped>

</style>
